export default __webpack_public_path__ + "static/media/reaction-haha.69e6dfbe.png";